import { SunThermometerIcon } from './SunThermometerIcon';

/**
 * author: Michael Irigoyen
 * id A915898D-3218-4A0E-9732-CEB0701DADA1
 * name sun-thermometer
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sun-thermometer.svg
 * tags
 * - Weather 
 * - Home Automation 
 */
export const SunTemperatureIcon = SunThermometerIcon;
export default SunTemperatureIcon